/**
 * Canonical ?audience= query values for the public homepage (aligned with Platform / Bot / Goals labels).
 * Legacy values (partner, customer, investors-regulators) are normalized on read and migrated in storage/URL.
 */
export const AUDIENCE = {
  PLATFORM: 'platform',
  BOT: 'bot',
  GOALS: 'goals',
};

const LEGACY_TO_CANONICAL = {
  partner: AUDIENCE.PLATFORM,
  customer: AUDIENCE.BOT,
  'investors-regulators': AUDIENCE.GOALS,
};

/**
 * @param {string|null|undefined} raw
 * @returns {typeof AUDIENCE[keyof typeof AUDIENCE]|null}
 */
export function normalizeAudienceParam(raw) {
  if (raw == null || raw === '') return null;
  const s = String(raw);
  if (LEGACY_TO_CANONICAL[s]) return LEGACY_TO_CANONICAL[s];
  if (s === AUDIENCE.PLATFORM || s === AUDIENCE.BOT || s === AUDIENCE.GOALS) return s;
  return null;
}

/**
 * Migrates localStorage audiencePreference from legacy strings to canonical.
 */
export function migrateAudiencePreferenceStorage() {
  if (typeof localStorage === 'undefined') return;
  const raw = localStorage.getItem('audiencePreference');
  const n = normalizeAudienceParam(raw);
  if (n && raw !== n) {
    localStorage.setItem('audiencePreference', n);
  }
}

/** Internal user-type strings (see userTypeContext USER_TYPES) ↔ canonical audience params */
export function canonicalToUserTypeString(canonical) {
  switch (canonical) {
    case AUDIENCE.PLATFORM:
      return 'partner';
    case AUDIENCE.BOT:
      return 'customer';
    case AUDIENCE.GOALS:
      return 'investors-regulators';
    default:
      return null;
  }
}

export function userTypeStringToCanonical(userType) {
  switch (userType) {
    case 'partner':
      return AUDIENCE.PLATFORM;
    case 'customer':
      return AUDIENCE.BOT;
    case 'investors-regulators':
      return AUDIENCE.GOALS;
    default:
      return AUDIENCE.BOT;
  }
}
